import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

const use_y = T('사용');
const use_n = T('미사용');
export default function PatientDeseaseInfo(props) {
  const {
    patient,
  } = props || {};
  const {
    diabetesDiagnosis,
    insulinUse,
  } = patient;
  return (
    <div {...ex('PatientDeseaseInfo', props)}>
      {!diabetesDiagnosis && T('인슐린 {0}', insulinUse === 'Y' ? use_y : use_n)}
      {diabetesDiagnosis && T('{0} - 인슐린 {1}', diabetesDiagnosis, insulinUse === 'Y' ? use_y : use_n)}
    </div>
  );
}
